import VueI18n from "vue-i18n";

export interface IChartLabels {
  title: string;
  color: string;
  key?: string;
}

export interface ITotalItem {
  key: string;
  title: string | VueI18n.TranslateResult;
  value: number;
  color: string;
}

export enum ACTION_TREATMENT_REQUEST {
  START = "START",
  VIEW = "VIEW",
  VIEWCERTIFICATE = "VIEWCERTIFICATE",
  EDIT = "EDIT",
  DELETE = "DELETE",
  CONTINUE = "CONTINUE",
  STOP = "STOP",
}

export const IN_REQUEST = "In Request";
export const IN_PROGRESS = "In Progress";
export const FINISHED = "Finished";
export const DRAFT = "Draft";
export const TREATMENT_SPECIAL = "Special";
export const PENDING = "Pending";
export const FAILURE = "Failure";
export const SPECIAL = "Special";

export const VALID = "Valid";
export const ACCEPTED = "Accepted";
export const NEEDSUPPORT = "Need Support";
export const APPROVED = "Approved";
export const REJECTED = "Rejected";
export const CANCELED = "Canceled";
export const CANCELLED = "Cancelled";

export const BASE_CHART_INIT = {
  chart: {
    width: "100%",
    type: "pie",
    events: {
      legendClick: (chartContext, seriesIndex, config) => {
      },
    },
  },
  stroke: {
    width: 0,
  },
  dataLabels: {
    enabled: false,
  },
  dataPointSelection: (event, chartContext, config) => {
  },
  legend: {
    show: true,
    showForSingleSeries: false,
    showForNullSeries: true,
    showForZeroSeries: true,
    position: "right",
    horizontalAlign: "center",
    floating: false,
    fontSize: "14px",
    fontFamily: "Helvetica, Arial",
    fontWeight: 400,
    formatter: (val, opts) => [
      val,
      ": ",
      opts.w.globals.series[opts.seriesIndex],
    ],
    offsetX: -30,
    offsetY: -10,
    labels: {
      colors: undefined,
      useSeriesColors: false,
    },
    markers: {
      width: 12,
      height: 12,
      strokeWidth: 0,
      strokeColor: "#fff",
      radius: 0,
      offsetX: 0,
      offsetY: 0,
      onClick: (chart, seriesIndex, opts) => {
      },
    },
    itemMargin: {
      horizontal: 0,
      vertical: 0,
    },
    onItemClick: {
      toggleDataSeries: true,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
  },

  plotOptions: {
    pie: {
      donut: {
        size: "80%",
        labels: {
          show: true,
          name: {
            offsetY: 6,
            fontSize: "16px",
            fontFamily: "Helvetica, Arial, sans-serif",
            show: false,
          },
          value: {
            offsetY: 30,
            fontSize: "36px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 600,
            show: false,
          },
          total: {
            show: false,
            showAlways: true,
            label: "Total",
            color: "#454F59",
            formatter: (w) =>
              w.globals.seriesTotals.reduce((a, b) => {
                return a + b;
              }, 0),
          },
        },
      },
    },
  },

  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: "right",
          show: true,
        },
      },
    },
  ],
};